import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { changePassword as changePasswordApi, recoverPasswordOnServer } from '../../util/api';

// ================ Async thunks ================ //

export const changePasswordThunk = createAsyncThunk(
  'PasswordChangePage/changePassword',
  async ({ newPassword, currentPassword }, { rejectWithValue }) => {
    try {
      await changePasswordApi({ currentPassword, newPassword });
      return true;
    } catch (e) {
      return rejectWithValue(storableError(e));
    }
  }
);
export const changePassword = params => dispatch => {
  const { newPassword, currentPassword } = params;
  return dispatch(changePasswordThunk({ newPassword, currentPassword }));
};

export const resetPasswordThunk = createAsyncThunk(
  'PasswordChangePage/resetPassword',
  async ({ email }, { rejectWithValue }) => {
    try {
      await recoverPasswordOnServer({ email });
      return true;
    } catch (e) {
      return rejectWithValue(storableError(e));
    }
  }
);
export const resetPassword = email => dispatch => {
  return dispatch(resetPasswordThunk({ email }));
};

// ================ Slice ================ //

const passwordChangeSlice = createSlice({
  name: 'PasswordChangePage',
  initialState: {
    changePasswordError: null,
    changePasswordInProgress: false,
    passwordChanged: false,
    resetPasswordInProgress: false,
    resetPasswordError: null,
  },
  reducers: {
    changePasswordClear: state => {
      state.changePasswordError = null;
      state.changePasswordInProgress = false;
      state.passwordChanged = false;
      state.resetPasswordInProgress = false;
      state.resetPasswordError = null;
    },
  },
  extraReducers: builder => {
    builder
      // Change password cases
      .addCase(changePasswordThunk.pending, state => {
        state.changePasswordInProgress = true;
        state.changePasswordError = null;
        state.passwordChanged = false;
      })
      .addCase(changePasswordThunk.fulfilled, state => {
        state.changePasswordInProgress = false;
        state.passwordChanged = true;
      })
      .addCase(changePasswordThunk.rejected, (state, action) => {
        console.error(action.payload);
        state.changePasswordInProgress = false;
        state.changePasswordError = action.payload;
      })
      // Reset password cases
      .addCase(resetPasswordThunk.pending, state => {
        state.resetPasswordInProgress = true;
        state.resetPasswordError = null;
      })
      .addCase(resetPasswordThunk.fulfilled, state => {
        state.resetPasswordInProgress = false;
      })
      .addCase(resetPasswordThunk.rejected, (state, action) => {
        console.error(action.payload);
        state.resetPasswordInProgress = false;
        state.resetPasswordError = action.payload;
      });
  },
});

export const { changePasswordClear } = passwordChangeSlice.actions;

export default passwordChangeSlice.reducer;
